import { TireRow } from "services/api/calculations/tire/types";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

export const CALCULATION_TIRE_SEARCH_COLUMNS: Column[] = [
  {
    title: "",
    field: "image",
    type: ColumnTypes.custom,
    render: (row: TireRow) => {
      return (
        <div>
          <div className="w-10 h-10 rounded-full bg-gray-200 block relative">
            <span className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"></span>
          </div>
        </div>
      );
    },
  },
  {
    title: "admin.calculation.tire.search.width",
    field: "",
    type: ColumnTypes.custom,
    render: (row) => {
      return (
        <div>
          <div className="text-md">{row.width}</div>
        </div>
      );
    },
  },
  {
    title: "admin.calculation.tire.search.height",
    field: "",
    type: ColumnTypes.custom,
    render: (row) => {
      return (
        <div>
          <div className="text-md">{row.height}</div>
        </div>
      );
    },
  },
  {
    title: "admin.calculation.tire.search.radius",
    field: "",
    type: ColumnTypes.custom,
    render: (row) => {
      return (
        <div>
          <div className="text-md">{row.radius}</div>
        </div>
      );
    },
  },
  {
    title: "admin.calculation.tire.search.changeprice",
    field: "",
    type: ColumnTypes.custom,
    render: (row) => {
      return (
        <div>
          <div className="text-md">{row.changePrice} €</div>
        </div>
      );
    },
  },
  {
    title: "admin.calculation.tire.search.hotelprice",
    field: "",
    type: ColumnTypes.custom,
    render: (row) => {
      return (
        <div>
          <div className="text-md">{row.hotelPrice} €</div>
        </div>
      );
    },
  },
];
